(()=>{
  function init(root){
    if(root.dataset.rfInitialized)return;
    root.dataset.rfInitialized='1';
    const form=root.querySelector('#rf-product-form');
    const id=form?.querySelector('[data-rf-variant-id]');
    const price=root.querySelector('[data-rf-price]');
    const stickyPrice=root.querySelector('[data-rf-sticky-price]');
    const image=root.querySelector('[data-rf-main],.rf-main-product-image');
    const add=root.querySelector('[data-rf-add]');
    const sticky=root.querySelector('[data-rf-sticky]');
    const stickySize=root.querySelector('[data-rf-sticky-size]');
    const nudge=root.querySelector('[data-rf-nudge]');
    const base=u=>(u||'').split('?')[0];
    const setImage=src=>{
      if(!image||!src)return;
      image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=src;
      root.querySelectorAll('.rf-thumb').forEach(el=>el.classList.toggle('is-active',base(el.dataset.rfImage)===base(src)));
    };
    const fmt=c=>{try{return new Intl.NumberFormat('en-GB',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'GBP'}).format(c/100)}catch(e){return (c/100).toFixed(2)}};
    let cartCents=0;
    const updateNudge=input=>{
      if(!nudge||!input)return;
      const rate=(window.Shopify&&Shopify.currency&&+Shopify.currency.rate)||1,c=+input.dataset.cents;
      if(!c){nudge.hidden=true;return}
      const total=cartCents+c;let shown=0;
      [['uk','UK'],['eu','EU']].forEach(([k,label])=>{
        const el=nudge.querySelector('[data-n-'+k+']'),t=Math.round(+nudge.dataset[k]*rate);
        if(!el)return;
        if(!t){el.hidden=true;return}
        el.hidden=false;shown++;
        el.textContent=total>=t?'You qualify for free '+label+' delivery.':'Add '+fmt(t-total)+' more for free '+label+' delivery.';
      });
      nudge.hidden=!shown;
    };
    updateNudge(root.querySelector('[data-rf-variant]:checked'));
    const syncCart=()=>fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(r=>r.json()).then(c=>{cartCents=+c.total_price||0;updateNudge(root.querySelector('[data-rf-variant]:checked'))}).catch(()=>{});
    if(nudge){
      syncCart();
      form?.addEventListener('submit',()=>setTimeout(syncCart,1500));
      ['cart:change','cart:refresh','cart:updated','cart:added'].forEach(e=>document.addEventListener(e,syncCart));
      window.addEventListener('pageshow',ev=>{if(ev.persisted)syncCart()});
    }
    root.querySelectorAll('[data-rf-variant]').forEach(input=>input.addEventListener('change',()=>{
      if(!input.checked || !id)return;
      id.value=input.value;updateNudge(input);
      price.textContent=input.dataset.priceMain;
      stickyPrice.textContent=input.dataset.price;
      if(stickySize)stickySize.value=input.value;
      root.querySelectorAll('.rf-variant').forEach(el=>el.classList.toggle('is-selected',el.contains(input)));
      if(input.dataset.image && image?.classList.contains('rf-main-product-image'))setImage(input.dataset.image);
      document.querySelectorAll('[data-rf-bundle-main-input]').forEach(el=>el.value=input.value);
      const url=new URL(location.href);url.searchParams.set('variant',input.value);
      history.replaceState(history.state,'',url);
    }));
    stickySize?.addEventListener('change',()=>{
      const radio=[...root.querySelectorAll('[data-rf-variant]')].find(el=>el.value===stickySize.value);
      if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
    });
    root.querySelectorAll('[data-rf-image]').forEach(button=>button.addEventListener('click',()=>{
      setImage(button.dataset.rfImage);
      root.querySelectorAll('.rf-thumb').forEach(el=>el.classList.toggle('is-active',el===button));
    }));
    /* Add first, refresh the Opus drawer, then open it — so it never flashes "Your Cart is Empty" */
    const nativeSubmit=()=>HTMLFormElement.prototype.submit.call(form);
    const submit=async()=>{
      if(!form||!add||add.disabled||add.getAttribute('aria-busy')==='true')return;
      add.setAttribute('aria-busy','true');add.classList.add('is-loading');
      window.opusNoListenerOpen=true;
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        if(r.status===422){const d=await r.json().catch(()=>({}));const t=add.innerHTML;add.textContent=d.description||'Not enough stock';setTimeout(()=>{add.innerHTML=t},2600);return}
        if(!r.ok){window.opusNoListenerOpen=false;nativeSubmit();return}
        try{if(window.opusRefreshCart)await window.opusRefreshCart()}catch(e){}
        if(window.opusOpen)window.opusOpen();else location.href='/cart';
        syncCart();
      }catch(e){window.opusNoListenerOpen=false;nativeSubmit();return}
      finally{add.removeAttribute('aria-busy');add.classList.remove('is-loading');setTimeout(()=>{window.opusNoListenerOpen=false},1500)}
    };
    window.addEventListener('click',e=>{if(add&&e.target.closest&&e.target.closest('[data-rf-add]')===add){e.preventDefault();e.stopImmediatePropagation();submit()}},true);
    root.querySelector('[data-rf-sticky-add]')?.addEventListener('click',submit);
    document.querySelectorAll('[data-rf-cta-add]').forEach(button=>{
      if(button.dataset.rfBound)return;
      button.dataset.rfBound='1';button.addEventListener('click',submit);
    });
    if(sticky && form){
      const observer=new IntersectionObserver(entries=>sticky.classList.toggle('is-visible',!entries[0].isIntersecting),{threshold:0});
      observer.observe(form);
    }
  }
  const boot=()=>document.querySelectorAll('[data-rf-product]').forEach(init);
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
  if(document.readyState!=='loading')boot();
})();

/* "You may also like" cards: same add -> refresh -> open flow as the main Add to Bag (no page reload, no empty drawer) */
(()=>{
  window.addEventListener('click',async e=>{
    const btn=e.target.closest&&e.target.closest('.rf-product-card form button[type="submit"]');
    if(!btn||btn.disabled)return;
    e.preventDefault();e.stopImmediatePropagation();
    if(btn.getAttribute('aria-busy')==='true')return;
    const form=btn.form,label=btn.innerHTML;
    btn.setAttribute('aria-busy','true');btn.classList.add('is-loading');window.opusNoListenerOpen=true;
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(r.status===422){const d=await r.json().catch(()=>({}));btn.textContent=d.description||'Not enough stock';setTimeout(()=>{btn.innerHTML=label},2600);return}
      if(!r.ok){HTMLFormElement.prototype.submit.call(form);return}
      try{if(window.opusRefreshCart)await window.opusRefreshCart()}catch(err){}
      if(window.opusOpen)window.opusOpen();else location.href='/cart';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(err){HTMLFormElement.prototype.submit.call(form)}
    finally{btn.removeAttribute('aria-busy');btn.classList.remove('is-loading');setTimeout(()=>{window.opusNoListenerOpen=false},1500)}
  },true);
})();

/* FAQ King (app embed) renders its FAQ mid-page; move it to the very bottom, just above the footer. */
(()=>{
  if(!document.querySelector('.rf-pdp'))return;
  let placed=false;
  const place=()=>{
    const faq=document.querySelector('.faq-container');
    if(!faq)return;
    if(faq.closest('.rf-faq-king')){placed=true;return}
    const foot=document.querySelector('.shopify-section-group-footer-group')||document.querySelector('footer');
    if(!foot||!foot.parentNode)return;
    const wrap=document.createElement('section');
    wrap.className='rf-faq-king';
    wrap.setAttribute('aria-label','Frequently asked questions');
    foot.parentNode.insertBefore(wrap,foot);
    wrap.appendChild(faq);
    placed=true;
  };
  const start=()=>{
    place();
    if(placed)return;
    const obs=new MutationObserver(()=>{place();if(placed)obs.disconnect()});
    obs.observe(document.body,{childList:true,subtree:true});
    setTimeout(()=>obs.disconnect(),30000);
  };
  if(document.readyState!=='loading')start();else document.addEventListener('DOMContentLoaded',start);
})();

/* B2: flag when the buying area (price, sizes, Add to Bag) is on screen so floating widgets step aside on mobile */
(()=>{
  const els=[...document.querySelectorAll('.rf-price-rating,.rf-variants,.rf-add')];
  if(!els.length||!('IntersectionObserver' in window))return;
  const on=new Set();
  const io=new IntersectionObserver(es=>{es.forEach(e=>e.isIntersecting?on.add(e.target):on.delete(e.target));document.documentElement.classList.toggle('rf-buy-in-view',on.size>0)},{threshold:0});
  els.forEach(el=>io.observe(el));
})();
